import React from 'react';

import classes from './modal.module.css';
import Backdrop from '../Backdrop/backdrop';
import Wrapper from '../../../wrapper/Wrapper';

const modal = (props) => {
    return (
        <Wrapper>
        <Backdrop show={props.show} 
                        dropBackDrop={props.openSummary}></Backdrop>
        <div className={classes.Modal}>
            {props.children}
        </div>
        </Wrapper>
    );
}

export default modal;